<section class="section-div">
  <div class="header-div">
    <h4><ion-icon name="happy-outline"></ion-icon> Knowledge & Expertise</h4>
  </div>
  <div class="content-details">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Objective">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              The objective of this focus area is making availabile the
              expertise to provide knowledge support to Startups in the
              technical, managerial, financial and legal aspects. Incubation
              Centers should provide support to develop knowledge among the
              stakeholders and entrepreneurial community by conducting knowledge
              development initiatives such as trainings, workshops, expert
              sessions, having a library, newsletters, blogs and by creating a
              digital content repository and hosting it. The incubator must also
              support IP protection such as filing of patent and copyrights
              wherever required.
            </li>
          </ul>
        </div>
      </mat-tab>
      <mat-tab label="Scoring Criteria">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              Skill Management; Mentorship; Knowledge Management; Role Mapping
            </li>
          </ul>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
      </div>

      <div class="row">
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-12"
          [formGroup]="settingsForm"
        >
          <mat-accordion>
            <!--001- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Mentor Network availabile ?
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.mentorNetworkStatus)"
                    [style.background]="pickColor(getValue.mentorNetworkStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.mentorNetworkStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Mentor Network availabile ?</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.mentorNetworkStatus != 2 &&
                        getValue.mentorNetworkStatus != 4 &&
                        getValue.mentorNetworkStatus != 5 &&
                        getValue.mentorNetworkStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="mentorNetworkIncCentre"
                          [(ngModel)]="Optionsonechecked"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionsone(
                              $event.value,
                              '.upload0',
                              0,
                              '.set-succ0'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.mentorNetworkIncCentre.touched &&
                              setting.mentorNetworkIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.mentorNetworkIncCentre.touched &&
                            setting.mentorNetworkIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.mentorNetworkIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsonechecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Mentors
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Mentors"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="mentorNetworkNoOfMentors"
                                (change)="
                                  setStatus($event, 'mentorNetworkStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.mentorNetworkNoOfMentors.touched &&
                                    setting.mentorNetworkNoOfMentors.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.mentorNetworkNoOfMentors.touched &&
                                  setting.mentorNetworkNoOfMentors.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.mentorNetworkNoOfMentors.errors
                                      .required
                                  "
                                  >No. of Mentors is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >Total Mentoring Hours
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter Total Mentoring Hours"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="mentorNetworkMentoringHours"
                                (change)="
                                  setStatus($event, 'mentorNetworkStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.mentorNetworkMentoringHours
                                      .touched &&
                                    setting.mentorNetworkMentoringHours.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.mentorNetworkMentoringHours.touched &&
                                  setting.mentorNetworkMentoringHours.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.mentorNetworkMentoringHours.errors
                                      .required
                                  "
                                  >Mentoring Hours is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload0">
                                  <input
                                    type="file"
                                    formControlName="mentorNetworkImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload0',
                                        0,
                                        '.set-succ0'
                                      )
                                    "
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.mentorNetworkImagefile
                                          .touched &&
                                        setting.mentorNetworkImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.mentorNetworkImagefile.touched &&
                                    setting.mentorNetworkImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.mentorNetworkImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload0"
                                  (click)="
                                    removeFile('.upload0', 0, '.set-succ0')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.mentorNetworkStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.mentorNetworkReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.mentorNetworkStatus == 2 ||
                        getValue.mentorNetworkStatus == 4 ||
                        getValue.mentorNetworkStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.mentorNetworkIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Mentors :
                            <b>{{ getValue.mentorNetworkNoOfMentors }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Total Mentoring Hours :
                            <b>{{ getValue.mentorNetworkMentoringHours }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.mentorNetworkDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.mentorNetworkStatus == 3 ||
                            getValue.mentorNetworkStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.mentorNetworkReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!--002 qusetion 010 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Mentor & Investor sensitization programs
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.mentorinvestorStatus)"
                    [style.background]="
                      pickColor(getValue.mentorinvestorStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                    27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.mentorinvestorStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Mentor & Investor sensitization programs</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.mentorinvestorStatus != 2 &&
                        getValue.mentorinvestorStatus != 4 &&
                        getValue.mentorinvestorStatus != 5 &&
                        getValue.mentorinvestorStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="mentorinvestorCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options10checked"
                          (change)="
                            showOptions10(
                              $event.value,
                              '.upload9',
                              9,
                              '.set-succ9'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.mentorinvestorCentre.touched &&
                              setting.mentorinvestorCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.mentorinvestorCentre.touched &&
                            setting.mentorinvestorCentre.errors
                          "
                        >
                          <span
                            *ngIf="setting.mentorinvestorCentre.errors.required"
                            >Documentary is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options10checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label>
                                No. of Programs
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Programs"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="mentorinvestorNoofprograms"
                                (change)="
                                  setStatus($event, 'mentorinvestorStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.mentorinvestorNoofprograms
                                      .touched &&
                                    setting.mentorinvestorNoofprograms.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.mentorinvestorNoofprograms.touched &&
                                  setting.mentorinvestorNoofprograms.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.mentorinvestorNoofprograms.errors
                                      .required
                                  "
                                  >No. of Programs is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload9">
                                  <input
                                    type="file"
                                    formControlName="mentorinvestorImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload9',
                                        9,
                                        '.set-succ9'
                                      )
                                    "
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.mentorinvestorImagefile
                                          .touched &&
                                        setting.mentorinvestorImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.mentorinvestorImagefile.touched &&
                                    setting.mentorinvestorImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.mentorinvestorImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload9"
                                  (click)="
                                    removeFile('.upload9', 9, '.set-succ9')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.mentorinvestorStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.mentorinvestorReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.mentorinvestorStatus == 2 ||
                        getValue.mentorinvestorStatus == 4 ||
                        getValue.mentorinvestorStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.mentorinvestorCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Programmes :
                            <b>{{ getValue.mentorinvestorNoofprograms }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.mentorinvestorDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.mentorinvestorStatus == 3 ||
                            getValue.mentorinvestorStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.mentorinvestorReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!--003 qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Expertise & Assistance provided for Startups under
                    Technical, Financial, Managerial, Legal areas, HR and Market
                    access
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.expertiseAssistanceStatus)
                    "
                    [style.background]="
                      pickColor(getValue.expertiseAssistanceStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                    27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.expertiseAssistanceStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Expertise & Assistance provided for Startups under
                      Technical, Financial, Managerial, Legal areas, HR and
                      Market access
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.expertiseAssistanceStatus != 2 &&
                        getValue.expertiseAssistanceStatus != 4 &&
                        getValue.expertiseAssistanceStatus != 5 &&
                        getValue.expertiseAssistanceStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="expertiseAssistanceIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionstwochecked"
                          (change)="
                            showOptionstwo(
                              $event.value,
                              '.upload1',
                              1,
                              '.set-succ1'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.expertiseAssistanceIncCentre.touched &&
                              setting.expertiseAssistanceIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.expertiseAssistanceIncCentre.touched &&
                            setting.expertiseAssistanceIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.expertiseAssistanceIncCentre.errors
                                .required
                            "
                            >Documentary is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionstwochecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                ><span class="text-danger">*</span> No. of
                                Startups benefitted from the Mentors under the
                                funtional areas
                              </mat-label>
                              <input
                                matInput
                                placeholder="Enter No. of Startups benefitted from the Mentors under the funtional areas"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="expertiseAssistanceNoOfProgrammes"
                                (change)="
                                  setStatus(
                                    $event,
                                    'expertiseAssistanceStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.expertiseAssistanceNoOfProgrammes
                                      .touched &&
                                    setting.expertiseAssistanceNoOfProgrammes
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.expertiseAssistanceNoOfProgrammes
                                    .touched &&
                                  setting.expertiseAssistanceNoOfProgrammes
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.expertiseAssistanceNoOfProgrammes
                                      .errors.required
                                  "
                                  >No. of Startups benefitted from the Mentors
                                  under the funtional areas is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload1">
                                  <input
                                    type="file"
                                    formControlName="expertiseAssistanceImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload1',
                                        1,
                                        '.set-succ1'
                                      )
                                    "
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.expertiseAssistanceImagefile
                                          .touched &&
                                        setting.expertiseAssistanceImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.expertiseAssistanceImagefile
                                      .touched &&
                                    setting.expertiseAssistanceImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.expertiseAssistanceImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload1"
                                  (click)="
                                    removeFile('.upload1', 1, '.set-succ1')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.expertiseAssistanceStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.expertiseAssistanceReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.expertiseAssistanceStatus == 2 ||
                        getValue.expertiseAssistanceStatus == 4 ||
                        getValue.expertiseAssistanceStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.expertiseAssistanceIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Startups benefitted from the Mentors under
                            the funtional areas :
                            <b>{{
                              getValue.expertiseAssistanceNoOfProgrammes
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.expertiseAssistanceDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.expertiseAssistanceStatus == 3 ||
                            getValue.expertiseAssistanceStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.expertiseAssistanceReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!--004 qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    IP cell for IP guidance and registration for Startups
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.guidanceRegistrationStatus)
                    "
                    [style.background]="
                      pickColor(getValue.guidanceRegistrationStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.guidanceRegistrationStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      IP cell for IP guidance and registration for Startups
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.guidanceRegistrationStatus != 2 &&
                        getValue.guidanceRegistrationStatus != 4 &&
                        getValue.guidanceRegistrationStatus != 5 &&
                        getValue.guidanceRegistrationStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="guidanceRegistrationIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsthreechecked"
                          (change)="
                            showOptionsthree(
                              $event.value,
                              '.upload2',
                              2,
                              '.set-succ2'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.guidanceRegistrationIncCentre.touched &&
                              setting.guidanceRegistrationIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.guidanceRegistrationIncCentre.touched &&
                            setting.guidanceRegistrationIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.guidanceRegistrationIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsthreechecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >URL from Incubation Center Website
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter URL from Incubation Center Website"
                                formControlName="guidanceRegistrationUrlIcWebsite"
                                (change)="
                                  setStatus(
                                    $event,
                                    'guidanceRegistrationStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.guidanceRegistrationUrlIcWebsite
                                      .touched &&
                                    setting.guidanceRegistrationUrlIcWebsite
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.guidanceRegistrationUrlIcWebsite
                                    .touched &&
                                  setting.guidanceRegistrationUrlIcWebsite
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.guidanceRegistrationUrlIcWebsite
                                      .errors.required
                                  "
                                  >URL from Incubation Center Website is
                                  required</span
                                >
                                <span
                                  *ngIf="
                                    setting.guidanceRegistrationUrlIcWebsite
                                      .errors.url
                                  "
                                  >Please enter proper url format</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload2">
                                  <input
                                    type="file"
                                    formControlName="guidanceRegistrationImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload2',
                                        2,
                                        '.set-succ2'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.guidanceRegistrationImagefile
                                          .touched &&
                                        setting.guidanceRegistrationImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.guidanceRegistrationImagefile
                                      .touched &&
                                    setting.guidanceRegistrationImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.guidanceRegistrationImagefile
                                        .errors.required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload2"
                                  (click)="
                                    removeFile('.upload2', 2, '.set-succ2')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.guidanceRegistrationStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.guidanceRegistrationReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.guidanceRegistrationStatus == 2 ||
                        getValue.guidanceRegistrationStatus == 4 ||
                        getValue.guidanceRegistrationStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.guidanceRegistrationIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.guidanceRegistrationUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{
                                  getValue.guidanceRegistrationUrlIcWebsite
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.guidanceRegistrationDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.guidanceRegistrationStatus == 3 ||
                            getValue.guidanceRegistrationStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.guidanceRegistrationReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!--005 qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)">
              <mat-expansion-panel-header class="d-flex">
                <h6>05.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    IP filed / granted to Startups facilitated by Incubation
                    Centre
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.filedGrantedStatus)"
                    [style.background]="pickColor(getValue.filedGrantedStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.filedGrantedStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>IP filed / granted to Startups facilitated by IC</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.filedGrantedStatus != 2 &&
                        getValue.filedGrantedStatus != 4 &&
                        getValue.filedGrantedStatus != 5 &&
                        getValue.filedGrantedStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="filedGrantedIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsfourchecked"
                          (change)="
                            showOptionsfour(
                              $event.value,
                              '.upload3',
                              3,
                              '.set-succ3'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.filedGrantedIncCentre.touched &&
                              setting.filedGrantedIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.filedGrantedIncCentre.touched &&
                            setting.filedGrantedIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.filedGrantedIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsfourchecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of IP granted
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of IP granted"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="filedGrantedNoOfIPFiled"
                                (change)="
                                  setStatus($event, 'filedGrantedStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.filedGrantedNoOfIPFiled.touched &&
                                    setting.filedGrantedNoOfIPFiled.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.filedGrantedNoOfIPFiled.touched &&
                                  setting.filedGrantedNoOfIPFiled.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.filedGrantedNoOfIPFiled.errors
                                      .required
                                  "
                                  >No of IP filed is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload3">
                                  <input
                                    type="file"
                                    formControlName="filedGrantedImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload3',
                                        3,
                                        '.set-succ3'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.filedGrantedImagefile.touched &&
                                        setting.filedGrantedImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.filedGrantedImagefile.touched &&
                                    setting.filedGrantedImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.filedGrantedImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload3"
                                  (click)="
                                    removeFile('.upload3', 3, '.set-succ3')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.filedGrantedStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="viewReasonBtn(getValue.filedGrantedReason)"
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.filedGrantedStatus == 2 ||
                        getValue.filedGrantedStatus == 4 ||
                        getValue.filedGrantedStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.filedGrantedIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of IP granted :
                            <b>{{ getValue.filedGrantedNoOfIPFiled }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.filedGrantedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.filedGrantedStatus == 3 ||
                            getValue.filedGrantedStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.filedGrantedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[4])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!--006 qusetion 005 -->
            <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)">
              <mat-expansion-panel-header class="d-flex">
                <h6>06.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    DPIIT registration awareness program for Startups
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.dpiitregistrationStatus)"
                    [style.background]="
                      pickColor(getValue.dpiitregistrationStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.dpiitregistrationStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>DPIIT registration awareness program for Startups</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.dpiitregistrationStatus != 2 &&
                        getValue.dpiitregistrationStatus != 4 &&
                        getValue.dpiitregistrationStatus != 5 &&
                        getValue.dpiitregistrationStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="dpiitregistrationIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsfivechecked"
                          (change)="
                            showOptionsfive(
                              $event.value,
                              '.upload4',
                              4,
                              '.set-succ4'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.dpiitregistrationIncCentre.touched &&
                              setting.dpiitregistrationIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.dpiitregistrationIncCentre.touched &&
                            setting.dpiitregistrationIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.dpiitregistrationIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsfivechecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No of programs
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No of programs"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="dpiitregistrationNoOfProgrammes"
                                (change)="
                                  setStatus(
                                    $event,
                                    'dpiitregistrationStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.dpiitregistrationNoOfProgrammes
                                      .touched &&
                                    setting.dpiitregistrationNoOfProgrammes
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.dpiitregistrationNoOfProgrammes
                                    .touched &&
                                  setting.dpiitregistrationNoOfProgrammes.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.dpiitregistrationNoOfProgrammes
                                      .errors.required
                                  "
                                  >No of programs is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload4">
                                  <input
                                    type="file"
                                    formControlName="dpiitregistrationImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload4',
                                        4,
                                        '.set-succ4'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.dpiitregistrationImagefile
                                          .touched &&
                                        setting.dpiitregistrationImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.dpiitregistrationImagefile
                                      .touched &&
                                    setting.dpiitregistrationImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.dpiitregistrationImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload4"
                                  (click)="
                                    removeFile('.upload4', 4, '.set-succ4')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.dpiitregistrationStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.dpiitregistrationReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.dpiitregistrationStatus == 2 ||
                        getValue.dpiitregistrationStatus == 4 ||
                        getValue.dpiitregistrationStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.dpiitregistrationIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of programs :
                            <b>{{
                              getValue.dpiitregistrationNoOfProgrammes
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.dpiitregistrationDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.dpiitregistrationStatus == 3 ||
                            getValue.dpiitregistrationStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.dpiitregistrationReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[5])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>

              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!--007 qusetion 006 -->
            <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)">
              <mat-expansion-panel-header>
                <h6>07.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    DPIIT Registered Startups
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.dpiitregistrationstartupsStatus)
                    "
                    [style.background]="
                      pickColor(getValue.dpiitregistrationstartupsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.dpiitregistrationstartupsStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>DPIIT Registered Startups</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.dpiitregistrationstartupsStatus != 2 &&
                        getValue.dpiitregistrationstartupsStatus != 4 &&
                        getValue.dpiitregistrationstartupsStatus != 5 &&
                        getValue.dpiitregistrationstartupsStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="dpiitregistrationstartupsIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionssixchecked"
                          (change)="
                            showOptionssix(
                              $event.value,
                              '.upload5',
                              5,
                              '.set-succ5'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.dpiitregistrationstartupsIncCentre
                                .touched &&
                              setting.dpiitregistrationstartupsIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.dpiitregistrationstartupsIncCentre
                              .touched &&
                            setting.dpiitregistrationstartupsIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.dpiitregistrationstartupsIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionssixchecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No of startups
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No of startups"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="incubateesdpiitrecogcount"
                                (change)="
                                  setStatus(
                                    $event,
                                    'dpiitregistrationstartupsStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.incubateesdpiitrecogcount.touched &&
                                    setting.incubateesdpiitrecogcount.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.incubateesdpiitrecogcount.touched &&
                                  setting.incubateesdpiitrecogcount.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.incubateesdpiitrecogcount.errors
                                      .required
                                  "
                                  >No of startups is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload5">
                                  <input
                                    type="file"
                                    formControlName="dpiitregistrationstartupsImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload5',
                                        5,
                                        '.set-succ5'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting
                                          .dpiitregistrationstartupsImagefile
                                          .touched &&
                                        setting
                                          .dpiitregistrationstartupsImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.dpiitregistrationstartupsImagefile
                                      .touched &&
                                    setting.dpiitregistrationstartupsImagefile
                                      .errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.dpiitregistrationstartupsImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload5"
                                  (click)="
                                    removeFile('.upload5', 5, '.set-succ5')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.dpiitregistrationstartupsStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.dpiitregistrationstartupsReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.dpiitregistrationstartupsStatus == 2 ||
                        getValue.dpiitregistrationstartupsStatus == 4 ||
                        getValue.dpiitregistrationstartupsStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.dpiitregistrationstartupsIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of startups :
                            <b>{{ getValue.incubateesdpiitrecogcount }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.dpiitregistrationstartupsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.dpiitregistrationstartupsStatus == 3 ||
                            getValue.dpiitregistrationstartupsStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.dpiitregistrationstartupsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[6])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!--008 qusetion 011 -->
            <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)">
              <mat-expansion-panel-header class="d-flex">
                <h6>08.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Pre-Incubation / Cohort based programs
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.preincubationcohortStatus)
                    "
                    [style.background]="
                      pickColor(getValue.preincubationcohortStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                    27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.preincubationcohortStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Pre-Incubation / Cohort based programs</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.preincubationcohortStatus != 2 &&
                        getValue.preincubationcohortStatus != 4 &&
                        getValue.preincubationcohortStatus != 5 &&
                        getValue.preincubationcohortStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="preincubationcohortCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options11checked"
                          (change)="
                            showOptions11(
                              $event.value,
                              '.upload10',
                              10,
                              '.set-succ10'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.preincubationcohortCentre.touched &&
                              setting.preincubationcohortCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.preincubationcohortCentre.touched &&
                            setting.preincubationcohortCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.preincubationcohortCentre.errors.required
                            "
                            >Documentary is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options11checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label>
                                No. of Programs
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Pre-Incubation"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="preincubationcohortNoofprograms"
                                (change)="
                                  setStatus(
                                    $event,
                                    'preincubationcohortStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.preincubationcohortNoofprograms
                                      .touched &&
                                    setting.preincubationcohortNoofprograms
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.preincubationcohortNoofprograms
                                    .touched &&
                                  setting.preincubationcohortNoofprograms.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.preincubationcohortNoofprograms
                                      .errors.required
                                  "
                                  >No. of Programs is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload10">
                                  <input
                                    type="file"
                                    formControlName="preincubationcohortImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload10',
                                        10,
                                        '.set-succ10'
                                      )
                                    "
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.preincubationcohortImagefile
                                          .touched &&
                                        setting.preincubationcohortImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.preincubationcohortImagefile
                                      .touched &&
                                    setting.preincubationcohortImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.preincubationcohortImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload10"
                                  (click)="
                                    removeFile('.upload10', 10, '.set-succ10')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.preincubationcohortStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.preincubationcohortReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.preincubationcohortStatus == 2 ||
                        getValue.preincubationcohortStatus == 4 ||
                        getValue.preincubationcohortStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.preincubationcohortCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Programmes :
                            <b>{{
                              getValue.preincubationcohortNoofprograms
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.preincubationcohortDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.preincubationcohortStatus == 3 ||
                            getValue.preincubationcohortStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.preincubationcohortReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[7])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!--009 qusetion 007 -->
            <mat-expansion-panel [expanded]="step === 8" (opened)="setStep(8)">
              <mat-expansion-panel-header>
                <h6>09.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Total physical and virtual Incubatees
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.totalPhysicalStatus)"
                    [style.background]="pickColor(getValue.totalPhysicalStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.totalPhysicalStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Total physical and virtual Incubatees</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.totalPhysicalStatus != 2 &&
                        getValue.totalPhysicalStatus != 4 &&
                        getValue.totalPhysicalStatus != 5 &&
                        getValue.totalPhysicalStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="totalPhysicalIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionssevenchecked"
                          (change)="
                            showOptionsseven(
                              $event.value,
                              '.upload6',
                              6,
                              '.set-succ6'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.totalPhysicalIncCentre.touched &&
                              setting.totalPhysicalIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No"
                            >No</mat-radio-button
                          > </mat-radio-group
                        ><br />
                        <mat-error
                          *ngIf="
                            setting.totalPhysicalIncCentre.touched &&
                            setting.totalPhysicalIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.totalPhysicalIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionssevenchecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="row">
                              <div class="col-lg-12 col-md-12 col-12">
                                <mat-form-field
                                  class="material-full-width"
                                  appearance="outline"
                                >
                                  <mat-label
                                    >No. of Physical Incubatees supported
                                    <span class="text-danger"
                                      >*</span
                                    ></mat-label
                                  >
                                  <input
                                    matInput
                                    placeholder="Enter Physical Incubatees supported"
                                    formControlName="noofPhysical"
                                    (change)="
                                      setStatus(
                                        $event,
                                        'totalPhysicalStatus',
                                        7
                                      )
                                    "
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.noofPhysical.touched &&
                                        setting.noofPhysical.errors
                                    }"
                                  />
                                  <mat-error
                                    *ngIf="
                                      setting.noofPhysical.touched &&
                                      setting.noofPhysical.errors
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        setting.noofPhysical.errors.required
                                      "
                                      >No. of Physical Incubatees
                                      supported</span
                                    >
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div class="col-lg-12 col-md-12 col-12">
                                <mat-form-field
                                  class="material-full-width"
                                  appearance="outline"
                                >
                                  <mat-label
                                    >No. of Virtual Incubatees supported
                                    <span class="text-danger"
                                      >*</span
                                    ></mat-label
                                  >
                                  <input
                                    matInput
                                    placeholder="Enter No. of Virtual Incubatees supported"
                                    formControlName="noofVirtual"
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                    (change)="
                                      setStatus(
                                        $event,
                                        'totalPhysicalStatus',
                                        7
                                      )
                                    "
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.noofVirtual.touched &&
                                        setting.noofVirtual.errors
                                    }"
                                  />
                                  <mat-error
                                    *ngIf="
                                      setting.noofVirtual.touched &&
                                      setting.noofVirtual.errors
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        setting.noofVirtual.errors.required
                                      "
                                      >No of Virtual Incubatees supported is
                                      required</span
                                    >
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload6">
                                  <input
                                    type="file"
                                    formControlName="totalPhysicalImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload6',
                                        6,
                                        '.set-succ6'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.totalPhysicalImagefile
                                          .touched &&
                                        setting.totalPhysicalImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.totalPhysicalImagefile.touched &&
                                    setting.totalPhysicalImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.totalPhysicalImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload6"
                                  (click)="
                                    removeFile('.upload6', 6, '.set-succ6')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.totalPhysicalStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.totalPhysicalReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.totalPhysicalStatus == 2 ||
                        getValue.totalPhysicalStatus == 4 ||
                        getValue.totalPhysicalStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.totalPhysicalIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Physical Incubatees supported :
                            <b>{{ getValue.noofPhysical }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Virtual Incubatees supported :
                            <b>{{ getValue.noofVirtual }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.totalPhysicalDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.totalPhysicalStatus == 3 ||
                            getValue.totalPhysicalStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.totalPhysicalReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[8])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>

              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!--010 qusetion 008 -->
            <mat-expansion-panel [expanded]="step === 9" (opened)="setStep(9)">
              <mat-expansion-panel-header class="d-flex">
                <h6>10.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Trainings / Workshops Conducted
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.trainingworkshopStatus)"
                    [style.background]="
                      pickColor(getValue.trainingworkshopStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                        27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.trainingworkshopStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Trainings / Workshops Conducted</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.trainingworkshopStatus != 2 &&
                        getValue.trainingworkshopStatus != 4 &&
                        getValue.trainingworkshopStatus != 5 &&
                        getValue.trainingworkshopStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="trainingworkshopCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptions8(
                              $event.value,
                              '.upload7',
                              7,
                              '.set-succ7'
                            )
                          "
                          [(ngModel)]="Options8checked"
                          [ngClass]="{
                            'is-invalid':
                              setting.trainingworkshopCentre.touched &&
                              setting.trainingworkshopCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.trainingworkshopCentre.touched &&
                            setting.trainingworkshopCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.trainingworkshopCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options8checked == 'Yes'">
                        <div class="row">
                          <!-- No. of Programs -->
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Programs
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Programs"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="trainingworkshopNoofprograms"
                                (change)="
                                  setStatus($event, 'trainingworkshopStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.trainingworkshopNoofprograms
                                      .touched &&
                                    setting.trainingworkshopNoofprograms.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.trainingworkshopNoofprograms
                                    .touched &&
                                  setting.trainingworkshopNoofprograms.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.trainingworkshopNoofprograms.errors
                                      .required
                                  "
                                  >No. of Programs is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload7">
                                  <input
                                    type="file"
                                    formControlName="trainingworkshopImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload7',
                                        7,
                                        '.set-succ7'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.trainingworkshopImagefile
                                          .touched &&
                                        setting.trainingworkshopImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.trainingworkshopImagefile.touched &&
                                    setting.trainingworkshopImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.trainingworkshopImagefile.errors
                                        .required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload7"
                                  (click)="
                                    removeFile('.upload7', 7, '.set-succ7')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.trainingworkshopStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.trainingworkshopReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.trainingworkshopStatus == 2 ||
                        getValue.trainingworkshopStatus == 4 ||
                        getValue.trainingworkshopStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.trainingworkshopCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Programs :
                            <b>{{ getValue.trainingworkshopNoofprograms }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.trainingworkshopDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.trainingworkshopStatus == 3 ||
                            getValue.trainingworkshopStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.trainingworkshopReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[9])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!--011 qusetion 009 -->
            <mat-expansion-panel
              [expanded]="step === 10"
              (opened)="setStep(10)"
            >
              <mat-expansion-panel-header class="d-flex">
                <h6>11.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Newletters and Access to Digital Library for the Startups
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.newlettersStatus)"
                    [style.background]="pickColor(getValue.newlettersStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                        27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.newlettersStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Newletters and Access to Digital Library for the Startups
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.newlettersStatus != 2 &&
                        getValue.newlettersStatus != 4 &&
                        getValue.newlettersStatus != 5 &&
                        getValue.newlettersStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="newlettersCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options9checked"
                          (change)="
                            showOptions9(
                              $event.value,
                              '.upload8',
                              8,
                              '.set-succ8'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.newlettersCentre.touched &&
                              setting.newlettersCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.newlettersCentre.touched &&
                            setting.newlettersCentre.errors
                          "
                        >
                          <span *ngIf="setting.newlettersCentre.errors.required"
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options9checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="row">
                              <div class="col-lg-12 col-md-12 col-12">
                                <mat-form-field
                                  class="material-full-width"
                                  appearance="outline"
                                >
                                  <mat-label
                                    >URL from Incubation Center Website
                                    <span class="text-danger"
                                      >*</span
                                    ></mat-label
                                  >
                                  <input
                                    matInput
                                    placeholder="Enter URL from Incubation Center Website"
                                    formControlName="newlettersUrlIcWebsite"
                                    (change)="
                                      setStatus($event, 'newlettersStatus', 7)
                                    "
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.newlettersUrlIcWebsite
                                          .touched &&
                                        setting.newlettersUrlIcWebsite.errors
                                    }"
                                  />
                                  <mat-error
                                    *ngIf="
                                      setting.newlettersUrlIcWebsite.touched &&
                                      setting.newlettersUrlIcWebsite.errors
                                    "
                                  >
                                    <span
                                      *ngIf="
                                        setting.newlettersUrlIcWebsite.errors
                                          .required
                                      "
                                      >URL from Incubation Center Website is
                                      required</span
                                    >
                                    <span
                                      *ngIf="
                                        setting.newlettersUrlIcWebsite.errors
                                          .url
                                      "
                                      >Please enter proper url format</span
                                    >
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <!-- <div class="col-lg-12 col-md-12 col-12">
                                                                <mat-form-field class="material-full-width"
                                                                    appearance="outline">
                                                                    <mat-label>No of Newletters <span
                                                                            class="text-danger">*</span></mat-label>
                                                                    <input matInput placeholder="Enter No of Newletters"
                                                                        formControlName="newlettersCount"
                                                                        oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                                                        (change)="setStatus($event,'newlettersStatus',7)"
                                                                        [ngClass]="{ 'is-invalid': setting.newlettersCount.touched && setting.newlettersCount.errors }">
                                                                    <mat-error
                                                                        *ngIf="setting.newlettersCount.touched && setting.newlettersCount.errors">
                                                                        <span
                                                                            *ngIf="setting.newlettersCount.errors.required">No
                                                                            of
                                                                            Newletters is
                                                                            required</span>
                                                                    </mat-error>
                                                                </mat-form-field>
                                                            </div> -->
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload8">
                                  <input
                                    type="file"
                                    formControlName="newlettersImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload8',
                                        8,
                                        '.set-succ8'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.newlettersImagefile.touched &&
                                        setting.newlettersImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.newlettersImagefile.touched &&
                                    setting.newlettersImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.newlettersImagefile.errors
                                        .required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload8"
                                  (click)="
                                    removeFile('.upload8', 8, '.set-succ8')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.newlettersStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="viewReasonBtn(getValue.newlettersReason)"
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.newlettersStatus == 2 ||
                        getValue.newlettersStatus == 4 ||
                        getValue.newlettersStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.newlettersCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{ getValue.newlettersUrlIcWebsite }}"
                                target="_blank"
                                >{{ getValue.newlettersUrlIcWebsite }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <!-- <div class="sub-div">
                                                    <p class="p-lbl">No of Newletters :
                                                        <b>{{getValue.newlettersCount}}</b>
                                                    </p>
                                                </div> -->
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="let list of getValue.newlettersDocuments"
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.newlettersStatus == 3 ||
                            getValue.newlettersStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.newlettersReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[10])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>

              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!--012 qusetion 012 -->
            <mat-expansion-panel
              [expanded]="step === 11"
              (opened)="setStep(11)"
            >
              <mat-expansion-panel-header class="d-flex">
                <h6>12.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Placement Drive for Startups
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.placementdriveStatus)"
                    [style.background]="
                      pickColor(getValue.placementdriveStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.placementdriveStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Placement Drive for Startups</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.placementdriveStatus != 2 &&
                        getValue.placementdriveStatus != 4 &&
                        getValue.placementdriveStatus != 5 &&
                        getValue.placementdriveStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="placementdriveCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options12checked"
                          (change)="
                            showOptions12(
                              $event.value,
                              '.upload11',
                              11,
                              '.set-succ11'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.placementdriveCentre.touched &&
                              setting.placementdriveCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.placementdriveCentre.touched &&
                            setting.placementdriveCentre.errors
                          "
                        >
                          <span
                            *ngIf="setting.placementdriveCentre.errors.required"
                            >Documentary is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options12checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label>
                                No. of Drives conducted for Startups
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Placement Drive for Startups"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="placementdriveNoofdrives"
                                (change)="
                                  setStatus($event, 'placementdriveStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.placementdriveNoofdrives.touched &&
                                    setting.placementdriveNoofdrives.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.placementdriveNoofdrives.touched &&
                                  setting.placementdriveNoofdrives.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.placementdriveNoofdrives.errors
                                      .required
                                  "
                                  >No. of Drives conducted for Startups
                                  required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload11">
                                  <input
                                    type="file"
                                    formControlName="placementdriveImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload11',
                                        11,
                                        '.set-succ11'
                                      )
                                    "
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.placementdriveImagefile
                                          .touched &&
                                        setting.placementdriveImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.placementdriveImagefile.touched &&
                                    setting.placementdriveImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.placementdriveImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload11"
                                  (click)="
                                    removeFile('.upload11', 11, '.set-succ11')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.placementdriveStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.placementdriveReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.placementdriveStatus == 2 ||
                        getValue.placementdriveStatus == 4 ||
                        getValue.placementdriveStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.placementdriveCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Drives conducted for Startups :
                            <b>{{ getValue.placementdriveNoofdrives }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.placementdriveDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.placementdriveStatus == 3 ||
                            getValue.placementdriveStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.placementdrivestartupsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[11])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
